import { Controller } from "@hotwired/stimulus"

export default class AdminTopupPackageController extends Controller {
  static values = {
    subscriptionId: String,
    lineDisplayName: String
  }

  showModal() {
    let dialog = document.getElementById("add-package-modal")
    let dialogSubtitle = dialog.querySelector("h2")
    dialogSubtitle.textContent = this.lineDisplayNameValue

    let dialogInputSubscription = dialog.querySelector("input[name='subscription_id']")
    dialogInputSubscription.value = this.subscriptionIdValue

    dialog.showModal()
  }
}
